class Navigation {
  navigate = () => {};

  setNavigation = (e) => {
    this.navigate = e;
  };
}
const AppNavigation = new Navigation();

export default AppNavigation;
